import { CropLandscapeIcon } from './CropLandscapeIcon';

/**
 * author: Google
 * id DE641C3F-FEF6-4764-A276-F6FECFE031DA
 * name crop-landscape
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/crop-landscape.svg
 * tags
 */
export const Crop54Icon = CropLandscapeIcon;
export default Crop54Icon